import React from 'react';
import Typography from '@mui/material/Typography';

const CISColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          CIS Control
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          CIS Subcontrol
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Asset Type
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Security Function
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Title
        </Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>
          Description
        </Typography>
      </div>
    </>
  );
};

export default CISColumns;
